const defaultLoading = false;

export default defaultLoading;
